import {
    ADD_ARTIST,
    ADD_ARTIST_SUCCESS,
    ADD_ARTIST_FAILURE,
    EDIT_ARTIST,
    EDIT_ARTIST_SUCCESS,
    EDIT_ARTIST_FAILURE,
    FETCH_ARTISTS,
    FETCH_ARTISTS_SUCCESS,
    FETCH_ARTISTS_FAILURE,
    FETCH_ARTIST,
    FETCH_ARTIST_SUCCESS,
    FETCH_ARTIST_FAILURE,
    DELETE_PICTURE,
    DELETE_ARTIST,
    DELETE_PICTURE_SUCCESS,
    DELETE_PICTURE_FAILURE,
    DELETE_ARTIST_FAILURE,
    DELETE_ARTIST_SUCCESS,
} from "../actions/Types"; // Make sure to import correct action types

const initialState = {
    artists: [],
    artist: null,
    loading: false,
    error: null,
    success: false,
};

const ArtistsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_ARTIST:
        case EDIT_ARTIST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };
        case FETCH_ARTISTS:
            return { ...state, loading: true, error: null };

        case ADD_ARTIST_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                // artists: [...state.artists, action.payload],
            };

        case EDIT_ARTIST_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                // artists: state.artists.map((artist) =>
                //     artist.id === action.payload.id ? action.payload : artist
                // ),
            };

        case FETCH_ARTISTS_SUCCESS:
            return {
                ...state,
                loading: false,
                artists: action.payload,
            };



        case ADD_ARTIST_FAILURE:
        case EDIT_ARTIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };
        case FETCH_ARTISTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };


        case FETCH_ARTIST:
            return { ...state, loading: true, error: null };

        case FETCH_ARTIST_SUCCESS:
            return { ...state, loading: false, artist: action.payload };

        case FETCH_ARTIST_FAILURE:
            return { ...state, loading: false, artist: null, error: action.payload };



        case DELETE_PICTURE:
        case DELETE_ARTIST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case DELETE_PICTURE_SUCCESS:
            return {
                ...state,
                loading: false,
            };

        case DELETE_ARTIST_SUCCESS:
            return {
                ...state,
                loading: false,
                // artists: state.artists.filter((artist) => artist.id !== action.payload),
            };

        case DELETE_PICTURE_FAILURE:
        case DELETE_ARTIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default ArtistsReducer;
